import sentryFetch from '@amzn/sentry-fetch';

const SENTRY_AUTH_MARKER_PREFIX = 'sentry-auth:';

/**
 * Calls the same-origin API through the supported ALI/Midway browser flow.
 *
 * The authorizer's identity token stays in its managed cookies and never
 * enters application JavaScript. SentryFetch handles `/sso/login`, Midway
 * step-up, and replaying the original request after authentication.
 */
export function midwayFetch(
    input: string | URL,
    init: RequestInit = {},
): Promise<Response> {
    return sentryFetch(input, {
        ...init,
        credentials: 'include',
        sentryOptions: {
            followMidwayStepUp: true,
        },
    });
}

/**
 * Clears SentryFetch's local freshness markers. This does not sign the user
 * out of Amazon Midway; it makes the next connection verify the session again.
 */
export function clearMidwaySession(): void {
    Object.keys(sessionStorage)
        .filter((key) => key.startsWith(SENTRY_AUTH_MARKER_PREFIX))
        .forEach((key) => sessionStorage.removeItem(key));
}
